// The current application coordinates were pre-registered in a B2C tenant.
const apiConfig = {
  b2cScopes: ["https://opennetlaborg.onmicrosoft.com/170cd5f3-4611-4882-a714-235c1390b138/demo.read"],
  // webApi: "https://fabrikamb2chello.azurewebsites.net/hello"
};

export default apiConfig;
